import { render, staticRenderFns } from "./NoItemsFound.vue?vue&type=template&id=8cc0f358&"
import script from "./NoItemsFound.vue?vue&type=script&lang=js&"
export * from "./NoItemsFound.vue?vue&type=script&lang=js&"
import style0 from "./NoItemsFound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports